import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05af2f88&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af2f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05af2f88')) {
      api.createRecord('05af2f88', component.options)
    } else {
      api.reload('05af2f88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05af2f88&scoped=true&", function () {
      api.rerender('05af2f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/index.vue"
export default component.exports